import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'core/translate';
import { SvgIcon } from 'core/icons';

const STANDARD = 'Standard';
const AVAILABLE = 'Available';
const NOT_AVAILABLE = 'N/A';

const Standard = ({ className }) => (
  <div className={className}>
    <SvgIcon name="check-circle" className="features-compare-feature__icon" />
    <Translate value="standard" />
  </div>
);

const Available = ({ className }) => (
  <div className={className}>
    <SvgIcon name="circle" className="features-compare-feature__icon" />
    <Translate value="available" />
  </div>
);

const NotAvailable = ({ className }) => (
  <div className={className}>
    <SvgIcon
      name="window-minimize"
      className="features-compare-feature__icon"
    />
    <Translate value="not.available" />
  </div>
);

const FeaturesCompareCell = ({ value, className }) => {
  if (value === STANDARD) {
    return <Standard className={className} />;
  }
  if (value === AVAILABLE) {
    return <Available className={className} />;
  }
  if (value === NOT_AVAILABLE) {
    return <NotAvailable className={className} />;
  }
  return (
    <div dangerouslySetInnerHTML={{ __html: value }} className={className} />
  );
};

FeaturesCompareCell.propTypes = {
  value: PropTypes.string,
  className: PropTypes.string
};

export default FeaturesCompareCell;
